"use client"

const HeaderGroupSkeleton = () => {
  return (
    <>
      {/* Desktop Skeleton */}
      <div className="bg-white shadow-2xl hidden lg:block">
        <div className="flex flex-col gap-3">
          <div className="max-w-full w-[1290px] mx-auto flex justify-between h-[74px] items-center">
            {/* Logo Skeleton - Left */}
            <div className="sm:w-[20%] px-[15px]">
              <div className="w-[180px] h-[17px] bg-gray-200 rounded animate-pulse" />
            </div>

            {/* Menu Items Skeleton - Center */}
            <div className="sm:w-[67.3%] px-[15px]">
              <nav className="relative">
                <ul className="flex justify-center gap-10 h-[70px] items-center">
                  {[1, 2, 3, 4, 5].map(item => (
                    <li key={item} className="h-5 w-20 bg-gray-200 rounded animate-pulse" />
                  ))}
                </ul>
              </nav>
            </div>

            {/* Language Selector Skeleton - Right */}
            <div className="sm:w-[12.7%] px-[15px] h-[70px] flex items-center justify-end">
              <div className="h-6 w-16 bg-gray-200 rounded animate-pulse" />
            </div>
          </div>
        </div>
      </div>

      {/* Mobile Skeleton */}
      <div className="block lg:hidden">
        <div className="items-center py-5 relative">
          <div className="flex justify-between items-center w-full h-[70px]">
            {/* Menu Icon Skeleton - Left */}
            <div className="px-[15px]">
              <div className="h-8 w-8 bg-gray-200 rounded animate-pulse" />
            </div>

            {/* Logo Skeleton - Center */}
            <div className="w-[220px] h-[26px] mx-[15px] bg-gray-200 rounded animate-pulse" />

            {/* Language Selector Skeleton - Right */}
            <div className="flex justify-end items-center gap-4 justify-items-center">
              <div className="pr-[15px]">
                <div className="h-6 w-12 bg-gray-200 rounded animate-pulse" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default HeaderGroupSkeleton
